// Module
var code = "<a class=\"btn btn-xs green\" ng-click=addElement() name=addbutton> <i class=\"fa fa-plus\"></i> </a>";
// Exports
module.exports = code;